module.exports = __webpack_public_path__ + "static/media/mongoDB.b1847af9.svg";